// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file ddtank/match/v1/match.proto (package ddtank.match.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Vector2 } from "../../common/v1/common_pb";
import { file_ddtank_common_v1_common } from "../../common/v1/common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ddtank/match/v1/match.proto.
 */
export const file_ddtank_match_v1_match: GenFile = /*@__PURE__*/
  fileDesc("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", [file_ddtank_common_v1_common]);

/**
 * @generated from message ddtank.match.v1.ClientMessage
 */
export type ClientMessage = Message<"ddtank.match.v1.ClientMessage"> & {
  /**
   * Eco no erro e na confirmação, para o cliente casar a resposta. Opcional.
   *
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from oneof ddtank.match.v1.ClientMessage.payload
   */
  payload: {
    /**
     * @generated from field: ddtank.match.v1.ListRoomsRequest list_rooms = 10;
     */
    value: ListRoomsRequest;
    case: "listRooms";
  } | {
    /**
     * @generated from field: ddtank.match.v1.CreateRoomRequest create_room = 11;
     */
    value: CreateRoomRequest;
    case: "createRoom";
  } | {
    /**
     * @generated from field: ddtank.match.v1.JoinRoomRequest join_room = 12;
     */
    value: JoinRoomRequest;
    case: "joinRoom";
  } | {
    /**
     * @generated from field: ddtank.match.v1.LeaveRoomRequest leave_room = 13;
     */
    value: LeaveRoomRequest;
    case: "leaveRoom";
  } | {
    /**
     * @generated from field: ddtank.match.v1.SetReadyRequest set_ready = 14;
     */
    value: SetReadyRequest;
    case: "setReady";
  } | {
    /**
     * @generated from field: ddtank.match.v1.StartGameRequest start_game = 15;
     */
    value: StartGameRequest;
    case: "startGame";
  } | {
    /**
     * @generated from field: ddtank.match.v1.EnqueueRequest enqueue = 16;
     */
    value: EnqueueRequest;
    case: "enqueue";
  } | {
    /**
     * @generated from field: ddtank.match.v1.DequeueRequest dequeue = 17;
     */
    value: DequeueRequest;
    case: "dequeue";
  } | {
    /**
     * @generated from field: ddtank.match.v1.KickMemberRequest kick_member = 18;
     */
    value: KickMemberRequest;
    case: "kickMember";
  } | {
    /**
     * @generated from field: ddtank.match.v1.EnqueueGroupRequest enqueue_group = 19;
     */
    value: EnqueueGroupRequest;
    case: "enqueueGroup";
  } | {
    /**
     * @generated from field: ddtank.match.v1.FriendsPresenceRequest friends_presence = 20;
     */
    value: FriendsPresenceRequest;
    case: "friendsPresence";
  } | {
    /**
     * @generated from field: ddtank.match.v1.InviteFriendRequest invite_friend = 21;
     */
    value: InviteFriendRequest;
    case: "inviteFriend";
  } | {
    /**
     * @generated from field: ddtank.match.v1.RefreshProfileRequest refresh_profile = 22;
     */
    value: RefreshProfileRequest;
    case: "refreshProfile";
  } | {
    /**
     * @generated from field: ddtank.match.v1.MoveRequest move = 30;
     */
    value: MoveRequest;
    case: "move";
  } | {
    /**
     * @generated from field: ddtank.match.v1.AimRequest aim = 31;
     */
    value: AimRequest;
    case: "aim";
  } | {
    /**
     * @generated from field: ddtank.match.v1.FireRequest fire = 32;
     */
    value: FireRequest;
    case: "fire";
  } | {
    /**
     * @generated from field: ddtank.match.v1.SkipTurnRequest skip_turn = 33;
     */
    value: SkipTurnRequest;
    case: "skipTurn";
  } | {
    /**
     * @generated from field: ddtank.match.v1.ResumeRequest resume = 34;
     */
    value: ResumeRequest;
    case: "resume";
  } | {
    /**
     * @generated from field: ddtank.match.v1.UseSkillRequest use_skill = 35;
     */
    value: UseSkillRequest;
    case: "useSkill";
  } | {
    /**
     * @generated from field: ddtank.match.v1.PingRequest ping = 50;
     */
    value: PingRequest;
    case: "ping";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message ddtank.match.v1.ClientMessage.
 * Use `create(ClientMessageSchema)` to create a new message.
 */
export const ClientMessageSchema: GenMessage<ClientMessage> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 0);

/**
 * @generated from message ddtank.match.v1.ListRoomsRequest
 */
export type ListRoomsRequest = Message<"ddtank.match.v1.ListRoomsRequest"> & {
};

/**
 * Describes the message ddtank.match.v1.ListRoomsRequest.
 * Use `create(ListRoomsRequestSchema)` to create a new message.
 */
export const ListRoomsRequestSchema: GenMessage<ListRoomsRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 1);

/**
 * Pede quem, entre os amigos da conta (lista do Character, ADR 0023), está online. A resposta é FriendsPresence, com o request_id. Sem campos:
 * o Match busca a lista no Character, então ninguém consulta a presença de quem não é seu amigo.
 *
 * @generated from message ddtank.match.v1.FriendsPresenceRequest
 */
export type FriendsPresenceRequest = Message<"ddtank.match.v1.FriendsPresenceRequest"> & {
};

/**
 * Describes the message ddtank.match.v1.FriendsPresenceRequest.
 * Use `create(FriendsPresenceRequestSchema)` to create a new message.
 */
export const FriendsPresenceRequestSchema: GenMessage<FriendsPresenceRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 2);

/**
 * Convida um amigo para a sala em que o jogador está. O amigo recebe RoomInvite. Só o código da sala vai; o amigo entra com JoinRoomRequest.code.
 * Erros: NOT_IN_ROOM, NOT_FRIEND, FRIEND_UNAVAILABLE (offline, em partida ou já nesta sala), INVITE_TOO_SOON, ROOM_QUEUED.
 *
 * @generated from message ddtank.match.v1.InviteFriendRequest
 */
export type InviteFriendRequest = Message<"ddtank.match.v1.InviteFriendRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message ddtank.match.v1.InviteFriendRequest.
 * Use `create(InviteFriendRequestSchema)` to create a new message.
 */
export const InviteFriendRequestSchema: GenMessage<InviteFriendRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 3);

/**
 * Pede ao Match que releia o visual e a arma do jogador no Character (por exemplo, depois de equipar uma arma na mochila). Sem campos: o cliente não
 * manda dado nenhum, o servidor lê a fonte. Se o jogador está numa sala de espera, a sala é reenviada a todos com o boneco novo. Sem resposta direta.
 *
 * @generated from message ddtank.match.v1.RefreshProfileRequest
 */
export type RefreshProfileRequest = Message<"ddtank.match.v1.RefreshProfileRequest"> & {
};

/**
 * Describes the message ddtank.match.v1.RefreshProfileRequest.
 * Use `create(RefreshProfileRequestSchema)` to create a new message.
 */
export const RefreshProfileRequestSchema: GenMessage<RefreshProfileRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 4);

/**
 * @generated from message ddtank.match.v1.FriendPresence
 */
export type FriendPresence = Message<"ddtank.match.v1.FriendPresence"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: bool online = 2;
   */
  online: boolean;

  /**
   * Está numa partida em andamento: online, mas sem receber convite.
   *
   * @generated from field: bool in_game = 3;
   */
  inGame: boolean;
};

/**
 * Describes the message ddtank.match.v1.FriendPresence.
 * Use `create(FriendPresenceSchema)` to create a new message.
 */
export const FriendPresenceSchema: GenMessage<FriendPresence> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 5);

/**
 * @generated from message ddtank.match.v1.FriendsPresence
 */
export type FriendsPresence = Message<"ddtank.match.v1.FriendsPresence"> & {
  /**
   * @generated from field: repeated ddtank.match.v1.FriendPresence friends = 1;
   */
  friends: FriendPresence[];
};

/**
 * Describes the message ddtank.match.v1.FriendsPresence.
 * Use `create(FriendsPresenceSchema)` to create a new message.
 */
export const FriendsPresenceSchema: GenMessage<FriendsPresence> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 6);

/**
 * Confirma o convite ao amigo (resposta de InviteFriendRequest, com o request_id).
 *
 * @generated from message ddtank.match.v1.InviteSent
 */
export type InviteSent = Message<"ddtank.match.v1.InviteSent"> & {
};

/**
 * Describes the message ddtank.match.v1.InviteSent.
 * Use `create(InviteSentSchema)` to create a new message.
 */
export const InviteSentSchema: GenMessage<InviteSent> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 7);

/**
 * Convite recebido de um amigo. O cliente mostra "Fulano convidou você" com Aceitar e Recusar; aceitar é entrar na sala pelo código.
 *
 * @generated from message ddtank.match.v1.RoomInvite
 */
export type RoomInvite = Message<"ddtank.match.v1.RoomInvite"> & {
  /**
   * @generated from field: string from_account_id = 1;
   */
  fromAccountId: string;

  /**
   * @generated from field: string from_nick = 2;
   */
  fromNick: string;

  /**
   * @generated from field: string join_code = 3;
   */
  joinCode: string;
};

/**
 * Describes the message ddtank.match.v1.RoomInvite.
 * Use `create(RoomInviteSchema)` to create a new message.
 */
export const RoomInviteSchema: GenMessage<RoomInvite> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 8);

/**
 * @generated from message ddtank.match.v1.CreateRoomRequest
 */
export type CreateRoomRequest = Message<"ddtank.match.v1.CreateRoomRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 1 a 5 jogadores por time (2 a 10 na sala).
   *
   * @generated from field: int32 team_size = 2;
   */
  teamSize: number;

  /**
   * Mapa do legado (docs/assets: collision/maps/<id>). 0 = sorteado ao iniciar.
   *
   * @generated from field: int32 map_id = 3;
   */
  mapId: number;

  /**
   * Vazia = sala pública. Senão, quem entra precisa informar.
   *
   * @generated from field: string password = 4;
   */
  password: string;
};

/**
 * Describes the message ddtank.match.v1.CreateRoomRequest.
 * Use `create(CreateRoomRequestSchema)` to create a new message.
 */
export const CreateRoomRequestSchema: GenMessage<CreateRoomRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 9);

/**
 * @generated from message ddtank.match.v1.JoinRoomRequest
 */
export type JoinRoomRequest = Message<"ddtank.match.v1.JoinRoomRequest"> & {
  /**
   * Vazio quando o jogador entra por código.
   *
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * Código curto da sala (5 dígitos, `RoomState.join_code`). Vale só quando room_id está vazio. Código sem sala: ROOM_NOT_FOUND.
   *
   * @generated from field: string code = 3;
   */
  code: string;
};

/**
 * Describes the message ddtank.match.v1.JoinRoomRequest.
 * Use `create(JoinRoomRequestSchema)` to create a new message.
 */
export const JoinRoomRequestSchema: GenMessage<JoinRoomRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 10);

/**
 * @generated from message ddtank.match.v1.LeaveRoomRequest
 */
export type LeaveRoomRequest = Message<"ddtank.match.v1.LeaveRoomRequest"> & {
};

/**
 * Describes the message ddtank.match.v1.LeaveRoomRequest.
 * Use `create(LeaveRoomRequestSchema)` to create a new message.
 */
export const LeaveRoomRequestSchema: GenMessage<LeaveRoomRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 11);

/**
 * Só o dono da sala. Tira outro membro da sala. O servidor recusa com NOT_ROOM_OWNER se quem pede não é o dono
 * e com INVALID_MESSAGE se o alvo é o próprio dono. Alvo fora da sala: NOT_IN_ROOM.
 *
 * @generated from message ddtank.match.v1.KickMemberRequest
 */
export type KickMemberRequest = Message<"ddtank.match.v1.KickMemberRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message ddtank.match.v1.KickMemberRequest.
 * Use `create(KickMemberRequestSchema)` to create a new message.
 */
export const KickMemberRequestSchema: GenMessage<KickMemberRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 12);

/**
 * @generated from message ddtank.match.v1.SetReadyRequest
 */
export type SetReadyRequest = Message<"ddtank.match.v1.SetReadyRequest"> & {
  /**
   * @generated from field: bool ready = 1;
   */
  ready: boolean;
};

/**
 * Describes the message ddtank.match.v1.SetReadyRequest.
 * Use `create(SetReadyRequestSchema)` to create a new message.
 */
export const SetReadyRequestSchema: GenMessage<SetReadyRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 13);

/**
 * Só o dono da sala. Exige todos prontos e os dois times com ao menos um jogador.
 *
 * @generated from message ddtank.match.v1.StartGameRequest
 */
export type StartGameRequest = Message<"ddtank.match.v1.StartGameRequest"> & {
};

/**
 * Describes the message ddtank.match.v1.StartGameRequest.
 * Use `create(StartGameRequestSchema)` to create a new message.
 */
export const StartGameRequestSchema: GenMessage<StartGameRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 14);

/**
 * @generated from message ddtank.match.v1.EnqueueRequest
 */
export type EnqueueRequest = Message<"ddtank.match.v1.EnqueueRequest"> & {
  /**
   * Tamanho do time desejado (1 a 5). Jogadores só casam com o mesmo valor.
   *
   * @generated from field: int32 team_size = 1;
   */
  teamSize: number;
};

/**
 * Describes the message ddtank.match.v1.EnqueueRequest.
 * Use `create(EnqueueRequestSchema)` to create a new message.
 */
export const EnqueueRequestSchema: GenMessage<EnqueueRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 15);

/**
 * Só o dono da sala. Põe a sala inteira na fila: ela enfrenta outra sala com o mesmo número de jogadores (1x1, 2x2, 3x3 ou 5x5).
 * A sala precisa ter 1, 2, 3 ou 5 jogadores, todos prontos e todos com arma equipada (WEAPON_REQUIRED). O servidor responde com QueueStatus para todos os membros.
 * Sair, expulsar ou entrar na sala tira o grupo da fila. A partida formada vira uma sala nova (MatchFound).
 *
 * @generated from message ddtank.match.v1.EnqueueGroupRequest
 */
export type EnqueueGroupRequest = Message<"ddtank.match.v1.EnqueueGroupRequest"> & {
};

/**
 * Describes the message ddtank.match.v1.EnqueueGroupRequest.
 * Use `create(EnqueueGroupRequestSchema)` to create a new message.
 */
export const EnqueueGroupRequestSchema: GenMessage<EnqueueGroupRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 16);

/**
 * Sai da fila. Para quem está numa sala na fila, só o dono pode pedir.
 *
 * @generated from message ddtank.match.v1.DequeueRequest
 */
export type DequeueRequest = Message<"ddtank.match.v1.DequeueRequest"> & {
};

/**
 * Describes the message ddtank.match.v1.DequeueRequest.
 * Use `create(DequeueRequestSchema)` to create a new message.
 */
export const DequeueRequestSchema: GenMessage<DequeueRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 17);

/**
 * Anda para a esquerda (-1) ou direita (1) por um passo. Só no turno do jogador. Cada PA de movimento paga um trecho de passos
 * (PlayerMoved.move_allowance); quando o trecho acaba, o passo seguinte paga outro PA.
 * Pedido para o lado oposto ao que o jogador olha só vira o jogador (PlayerMoved com o novo facing): não anda e não gasta PA. O passo vem no pedido seguinte.
 * Sem PA, o pedido para o mesmo lado devolve NO_ACTION_POINTS. Passo para um degrau mais baixo que o limite do passo desce até o chão (como o legado);
 * passo para o vazio, sem chão embaixo, faz o jogador cair do mapa e morrer (PlayerMoved.fell).
 *
 * @generated from message ddtank.match.v1.MoveRequest
 */
export type MoveRequest = Message<"ddtank.match.v1.MoveRequest"> & {
  /**
   * @generated from field: int32 direction = 1;
   */
  direction: number;
};

/**
 * Describes the message ddtank.match.v1.MoveRequest.
 * Use `create(MoveRequestSchema)` to create a new message.
 */
export const MoveRequestSchema: GenMessage<MoveRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 18);

/**
 * Ângulo do canhão em graus (0 a 360, 0 = direita, anti-horário).
 *
 * @generated from message ddtank.match.v1.AimRequest
 */
export type AimRequest = Message<"ddtank.match.v1.AimRequest"> & {
  /**
   * @generated from field: float angle = 1;
   */
  angle: number;
};

/**
 * Describes the message ddtank.match.v1.AimRequest.
 * Use `create(AimRequestSchema)` to create a new message.
 */
export const AimRequestSchema: GenMessage<AimRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 19);

/**
 * @generated from message ddtank.match.v1.FireRequest
 */
export type FireRequest = Message<"ddtank.match.v1.FireRequest"> & {
  /**
   * Ângulo em graus, como em AimRequest. Tem de apontar para o lado em que o jogador olha (Combatant.facing / PlayerMoved.facing);
   * 90° vale para os dois lados. Para o lado oposto, a resposta é INVALID_MESSAGE e o turno continua.
   *
   * @generated from field: float angle = 1;
   */
  angle: number;

  /**
   * Força 1 a 100.
   *
   * @generated from field: int32 power = 2;
   */
  power: number;

  /**
   * Bomba especial (usa Ball.Power do Damage).
   *
   * @generated from field: bool special = 3;
   */
  special: boolean;
};

/**
 * Describes the message ddtank.match.v1.FireRequest.
 * Use `create(FireRequestSchema)` to create a new message.
 */
export const FireRequestSchema: GenMessage<FireRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 20);

/**
 * @generated from message ddtank.match.v1.SkipTurnRequest
 */
export type SkipTurnRequest = Message<"ddtank.match.v1.SkipTurnRequest"> & {
};

/**
 * Describes the message ddtank.match.v1.SkipTurnRequest.
 * Use `create(SkipTurnRequestSchema)` to create a new message.
 */
export const SkipTurnRequestSchema: GenMessage<SkipTurnRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 21);

/**
 * Usa uma habilidade de arma ou acessório (a que os itens equipados concedem; ver Combatant.skills). Gasta PA (skillCost, ou o custo da habilidade),
 * entra em cooldown (turnos do próprio usuário) e responde com SkillUsed para todos. Só no turno do jogador.
 *
 * @generated from message ddtank.match.v1.UseSkillRequest
 */
export type UseSkillRequest = Message<"ddtank.match.v1.UseSkillRequest"> & {
  /**
   * @generated from field: int32 skill_id = 1;
   */
  skillId: number;

  /**
   * Alvo. Vazio vale para habilidades de si mesmo, de aliado (usa o próprio jogador) e de adversário quando só há um.
   *
   * @generated from field: string target_id = 2;
   */
  targetId: string;
};

/**
 * Describes the message ddtank.match.v1.UseSkillRequest.
 * Use `create(UseSkillRequestSchema)` to create a new message.
 */
export const UseSkillRequestSchema: GenMessage<UseSkillRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 22);

/**
 * Reconexão: pede o estado atual da sala ou da partida em que o jogador estava.
 *
 * @generated from message ddtank.match.v1.ResumeRequest
 */
export type ResumeRequest = Message<"ddtank.match.v1.ResumeRequest"> & {
};

/**
 * Describes the message ddtank.match.v1.ResumeRequest.
 * Use `create(ResumeRequestSchema)` to create a new message.
 */
export const ResumeRequestSchema: GenMessage<ResumeRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 23);

/**
 * @generated from message ddtank.match.v1.PingRequest
 */
export type PingRequest = Message<"ddtank.match.v1.PingRequest"> & {
  /**
   * @generated from field: int64 client_time_ms = 1;
   */
  clientTimeMs: bigint;
};

/**
 * Describes the message ddtank.match.v1.PingRequest.
 * Use `create(PingRequestSchema)` to create a new message.
 */
export const PingRequestSchema: GenMessage<PingRequest> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 24);

/**
 * @generated from message ddtank.match.v1.ServerMessage
 */
export type ServerMessage = Message<"ddtank.match.v1.ServerMessage"> & {
  /**
   * Preenchido quando a mensagem responde a uma ClientMessage com request_id.
   *
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from oneof ddtank.match.v1.ServerMessage.payload
   */
  payload: {
    /**
     * @generated from field: ddtank.match.v1.Welcome welcome = 10;
     */
    value: Welcome;
    case: "welcome";
  } | {
    /**
     * @generated from field: ddtank.match.v1.ErrorMessage error = 11;
     */
    value: ErrorMessage;
    case: "error";
  } | {
    /**
     * @generated from field: ddtank.match.v1.Pong pong = 12;
     */
    value: Pong;
    case: "pong";
  } | {
    /**
     * @generated from field: ddtank.match.v1.RoomList room_list = 20;
     */
    value: RoomList;
    case: "roomList";
  } | {
    /**
     * @generated from field: ddtank.match.v1.RoomState room = 21;
     */
    value: RoomState;
    case: "room";
  } | {
    /**
     * @generated from field: ddtank.match.v1.RoomClosed room_closed = 22;
     */
    value: RoomClosed;
    case: "roomClosed";
  } | {
    /**
     * @generated from field: ddtank.match.v1.QueueStatus queue = 23;
     */
    value: QueueStatus;
    case: "queue";
  } | {
    /**
     * @generated from field: ddtank.match.v1.MatchFound match_found = 24;
     */
    value: MatchFound;
    case: "matchFound";
  } | {
    /**
     * @generated from field: ddtank.match.v1.FriendsPresence friends_presence = 25;
     */
    value: FriendsPresence;
    case: "friendsPresence";
  } | {
    /**
     * @generated from field: ddtank.match.v1.RoomInvite room_invite = 26;
     */
    value: RoomInvite;
    case: "roomInvite";
  } | {
    /**
     * @generated from field: ddtank.match.v1.InviteSent invite_sent = 27;
     */
    value: InviteSent;
    case: "inviteSent";
  } | {
    /**
     * @generated from field: ddtank.match.v1.GameStarted game_started = 40;
     */
    value: GameStarted;
    case: "gameStarted";
  } | {
    /**
     * @generated from field: ddtank.match.v1.TurnStarted turn_started = 41;
     */
    value: TurnStarted;
    case: "turnStarted";
  } | {
    /**
     * @generated from field: ddtank.match.v1.PlayerMoved player_moved = 42;
     */
    value: PlayerMoved;
    case: "playerMoved";
  } | {
    /**
     * @generated from field: ddtank.match.v1.ShotResolved shot = 43;
     */
    value: ShotResolved;
    case: "shot";
  } | {
    /**
     * @generated from field: ddtank.match.v1.GameSnapshot snapshot = 44;
     */
    value: GameSnapshot;
    case: "snapshot";
  } | {
    /**
     * @generated from field: ddtank.match.v1.GameFinished game_finished = 45;
     */
    value: GameFinished;
    case: "gameFinished";
  } | {
    /**
     * @generated from field: ddtank.match.v1.SkillUsed skill_used = 46;
     */
    value: SkillUsed;
    case: "skillUsed";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message ddtank.match.v1.ServerMessage.
 * Use `create(ServerMessageSchema)` to create a new message.
 */
export const ServerMessageSchema: GenMessage<ServerMessage> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 25);

/**
 * @generated from message ddtank.match.v1.Welcome
 */
export type Welcome = Message<"ddtank.match.v1.Welcome"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: int32 protocol_version = 2;
   */
  protocolVersion: number;

  /**
   * Já estava numa sala ou partida (reconexão): o estado vem em seguida.
   *
   * @generated from field: bool has_active_session = 3;
   */
  hasActiveSession: boolean;

  /**
   * Sala ou partida em que o jogador está (vazio se nenhuma). Serve de dica de afinidade: reconectar com ?room=<id>.
   *
   * @generated from field: string active_room_id = 4;
   */
  activeRoomId: string;
};

/**
 * Describes the message ddtank.match.v1.Welcome.
 * Use `create(WelcomeSchema)` to create a new message.
 */
export const WelcomeSchema: GenMessage<Welcome> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 26);

/**
 * @generated from message ddtank.match.v1.ErrorMessage
 */
export type ErrorMessage = Message<"ddtank.match.v1.ErrorMessage"> & {
  /**
   * @generated from field: ddtank.match.v1.ErrorCode code = 1;
   */
  code: ErrorCode;

  /**
   * Texto para log; o cliente deve decidir a interface pelo code.
   *
   * @generated from field: string detail = 2;
   */
  detail: string;
};

/**
 * Describes the message ddtank.match.v1.ErrorMessage.
 * Use `create(ErrorMessageSchema)` to create a new message.
 */
export const ErrorMessageSchema: GenMessage<ErrorMessage> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 27);

/**
 * @generated from message ddtank.match.v1.Pong
 */
export type Pong = Message<"ddtank.match.v1.Pong"> & {
  /**
   * @generated from field: int64 client_time_ms = 1;
   */
  clientTimeMs: bigint;

  /**
   * @generated from field: int64 server_time_ms = 2;
   */
  serverTimeMs: bigint;
};

/**
 * Describes the message ddtank.match.v1.Pong.
 * Use `create(PongSchema)` to create a new message.
 */
export const PongSchema: GenMessage<Pong> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 28);

/**
 * @generated from message ddtank.match.v1.RoomSummary
 */
export type RoomSummary = Message<"ddtank.match.v1.RoomSummary"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int32 team_size = 3;
   */
  teamSize: number;

  /**
   * @generated from field: int32 map_id = 4;
   */
  mapId: number;

  /**
   * @generated from field: int32 players = 5;
   */
  players: number;

  /**
   * @generated from field: bool has_password = 6;
   */
  hasPassword: boolean;

  /**
   * @generated from field: ddtank.match.v1.RoomStatus status = 7;
   */
  status: RoomStatus;
};

/**
 * Describes the message ddtank.match.v1.RoomSummary.
 * Use `create(RoomSummarySchema)` to create a new message.
 */
export const RoomSummarySchema: GenMessage<RoomSummary> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 29);

/**
 * @generated from message ddtank.match.v1.RoomList
 */
export type RoomList = Message<"ddtank.match.v1.RoomList"> & {
  /**
   * @generated from field: repeated ddtank.match.v1.RoomSummary rooms = 1;
   */
  rooms: RoomSummary[];
};

/**
 * Describes the message ddtank.match.v1.RoomList.
 * Use `create(RoomListSchema)` to create a new message.
 */
export const RoomListSchema: GenMessage<RoomList> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 30);

/**
 * @generated from message ddtank.match.v1.RoomMember
 */
export type RoomMember = Message<"ddtank.match.v1.RoomMember"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string nick_name = 2;
   */
  nickName: string;

  /**
   * @generated from field: ddtank.match.v1.Team team = 3;
   */
  team: Team;

  /**
   * @generated from field: bool ready = 4;
   */
  ready: boolean;

  /**
   * @generated from field: bool is_owner = 5;
   */
  isOwner: boolean;

  /**
   * @generated from field: int32 grade = 6;
   */
  grade: number;

  /**
   * Visual para desenhar o boneco na sala: sexo (true = masculino) e ids dos itens de visual, separados por vírgula. Não entram no combate.
   *
   * @generated from field: bool sex = 7;
   */
  sex: boolean;

  /**
   * @generated from field: string style = 8;
   */
  style: string;

  /**
   * Modelo da arma equipada (0 = sem arma): o boneco da sala a segura na mão, como o `ShowCharacter` do legado (`showGun`). Não entra no combate.
   *
   * @generated from field: int32 weapon_template_id = 9;
   */
  weaponTemplateId: number;

  /**
   * Brilho do boneco parado: roupa * 100 + arma, cada parte de 0 a 3 (ADR 0029). Só desenha; não entra no combate.
   *
   * @generated from field: int32 nimbus = 10;
   */
  nimbus: number;

  /**
   * Nível de fortalecimento da arma equipada: o cliente escolhe a imagem da arma por nível (ADR 0036). Só desenha; não entra no combate.
   *
   * @generated from field: int32 weapon_strengthen_level = 11;
   */
  weaponStrengthenLevel: number;
};

/**
 * Describes the message ddtank.match.v1.RoomMember.
 * Use `create(RoomMemberSchema)` to create a new message.
 */
export const RoomMemberSchema: GenMessage<RoomMember> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 31);

/**
 * Estado completo da sala; reenviado a todos os membros a cada mudança.
 *
 * @generated from message ddtank.match.v1.RoomState
 */
export type RoomState = Message<"ddtank.match.v1.RoomState"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int32 team_size = 3;
   */
  teamSize: number;

  /**
   * @generated from field: int32 map_id = 4;
   */
  mapId: number;

  /**
   * @generated from field: ddtank.match.v1.RoomStatus status = 5;
   */
  status: RoomStatus;

  /**
   * @generated from field: repeated ddtank.match.v1.RoomMember members = 6;
   */
  members: RoomMember[];

  /**
   * Código curto para convidar amigos: 5 dígitos, único entre as salas abertas. Vazio nas salas criadas pela fila.
   *
   * @generated from field: string join_code = 7;
   */
  joinCode: string;
};

/**
 * Describes the message ddtank.match.v1.RoomState.
 * Use `create(RoomStateSchema)` to create a new message.
 */
export const RoomStateSchema: GenMessage<RoomState> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 32);

/**
 * O jogador não está mais na sala (saiu, a sala acabou ou a partida terminou).
 *
 * @generated from message ddtank.match.v1.RoomClosed
 */
export type RoomClosed = Message<"ddtank.match.v1.RoomClosed"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: ddtank.match.v1.RoomClosedReason reason = 2;
   */
  reason: RoomClosedReason;
};

/**
 * Describes the message ddtank.match.v1.RoomClosed.
 * Use `create(RoomClosedSchema)` to create a new message.
 */
export const RoomClosedSchema: GenMessage<RoomClosed> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 33);

/**
 * @generated from message ddtank.match.v1.QueueStatus
 */
export type QueueStatus = Message<"ddtank.match.v1.QueueStatus"> & {
  /**
   * @generated from field: bool queued = 1;
   */
  queued: boolean;

  /**
   * @generated from field: int32 team_size = 2;
   */
  teamSize: number;

  /**
   * @generated from field: int32 waiting = 3;
   */
  waiting: number;

  /**
   * @generated from field: int32 waited_seconds = 4;
   */
  waitedSeconds: number;
};

/**
 * Describes the message ddtank.match.v1.QueueStatus.
 * Use `create(QueueStatusSchema)` to create a new message.
 */
export const QueueStatusSchema: GenMessage<QueueStatus> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 34);

/**
 * A fila formou uma partida; o jogador já está na sala (room_id) e a partida começa em seguida.
 *
 * @generated from message ddtank.match.v1.MatchFound
 */
export type MatchFound = Message<"ddtank.match.v1.MatchFound"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;
};

/**
 * Describes the message ddtank.match.v1.MatchFound.
 * Use `create(MatchFoundSchema)` to create a new message.
 */
export const MatchFoundSchema: GenMessage<MatchFound> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 35);

/**
 * @generated from message ddtank.match.v1.Combatant
 */
export type Combatant = Message<"ddtank.match.v1.Combatant"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string nick_name = 2;
   */
  nickName: string;

  /**
   * @generated from field: ddtank.match.v1.Team team = 3;
   */
  team: Team;

  /**
   * @generated from field: ddtank.common.v1.Vector2 position = 4;
   */
  position?: Vector2 | undefined;

  /**
   * @generated from field: int32 blood = 5;
   */
  blood: number;

  /**
   * @generated from field: int32 max_blood = 6;
   */
  maxBlood: number;

  /**
   * 1 = olhando para a direita, -1 = esquerda.
   *
   * @generated from field: int32 facing = 7;
   */
  facing: number;

  /**
   * @generated from field: bool alive = 8;
   */
  alive: boolean;

  /**
   * Pontos de ação (PA) que sobram no turno; o jogador que não está na vez tem os do próximo turno só depois que ele começa.
   *
   * @generated from field: int32 action_points = 9;
   */
  actionPoints: number;

  /**
   * Fúria 0 a 200; com 200 o jogador pode atirar a bomba especial.
   *
   * @generated from field: int32 dander = 10;
   */
  dander: number;

  /**
   * @generated from field: bool connected = 11;
   */
  connected: boolean;

  /**
   * PA com que o jogador começa o turno (base + Sabedoria / divisor).
   *
   * @generated from field: int32 max_action_points = 12;
   */
  maxActionPoints: number;

  /**
   * Quanto ainda anda (em pixels) com o PA de movimento já pago.
   *
   * @generated from field: int32 move_allowance = 13;
   */
  moveAllowance: number;

  /**
   * Habilidades de arma e acessório deste jogador e quantos turnos dele faltam para cada uma voltar.
   *
   * @generated from field: repeated ddtank.match.v1.SkillState skills = 14;
   */
  skills: SkillState[];

  /**
   * Buffs, debuffs e provocações em vigor neste jogador.
   *
   * @generated from field: repeated ddtank.match.v1.EffectState effects = 15;
   */
  effects: EffectState[];

  /**
   * Inclinação do chão sob o jogador, em graus, medida pelo servidor (positivo: sobe para a direita). É o 0° da mira.
   *
   * @generated from field: float tilt = 16;
   */
  tilt: number;

  /**
   * Faixa de mira da arma equipada em graus: a mira vai de 0° (a inclinação do chão) até +angle_range°, para o lado em que o jogador olha.
   *
   * @generated from field: int32 angle_range = 17;
   */
  angleRange: number;

  /**
   * Visual do personagem, só para o cliente desenhar: sexo (true = masculino), a lista de peças do Character separada por vírgula
   * e o modelo da arma equipada (0 = sem arma). O servidor não usa o visual para nenhuma regra.
   *
   * @generated from field: bool sex = 18;
   */
  sex: boolean;

  /**
   * @generated from field: string style = 19;
   */
  style: string;

  /**
   * @generated from field: int32 weapon_template_id = 20;
   */
  weaponTemplateId: number;

  /**
   * O jogador desistiu da partida (saiu ou perdeu a conexão por tempo demais). Com alive = false, o cliente mostra a saída de quem desiste, e não a queda de quem morreu.
   *
   * @generated from field: bool forfeited = 21;
   */
  forfeited: boolean;

  /**
   * Brilho do boneco parado (roupa * 100 + arma), para a tela de confronto (ADR 0029).
   *
   * @generated from field: int32 nimbus = 22;
   */
  nimbus: number;

  /**
   * Bombas de desenho que o estágio visual da arma troca (ADR 0032): o cliente baixa a arte delas antes do primeiro tiro. Vazio = o visual da arma não troca.
   *
   * @generated from field: repeated int32 visual_ball_ids = 23;
   */
  visualBallIds: number[];

  /**
   * Nível de fortalecimento da arma equipada, para o cliente escolher a imagem da arma por nível (ADR 0036). Só desenha.
   *
   * @generated from field: int32 weapon_strengthen_level = 24;
   */
  weaponStrengthenLevel: number;
};

/**
 * Describes the message ddtank.match.v1.Combatant.
 * Use `create(CombatantSchema)` to create a new message.
 */
export const CombatantSchema: GenMessage<Combatant> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 36);

/**
 * @generated from message ddtank.match.v1.SkillState
 */
export type SkillState = Message<"ddtank.match.v1.SkillState"> & {
  /**
   * @generated from field: int32 skill_id = 1;
   */
  skillId: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: ddtank.match.v1.SkillKind kind = 3;
   */
  kind: SkillKind;

  /**
   * @generated from field: ddtank.match.v1.SkillTarget target = 4;
   */
  target: SkillTarget;

  /**
   * Turnos do próprio jogador para a habilidade poder ser usada de novo (0 = pronta).
   *
   * @generated from field: int32 cooldown_left = 5;
   */
  cooldownLeft: number;

  /**
   * Cooldown total ao usar.
   *
   * @generated from field: int32 cooldown_turns = 6;
   */
  cooldownTurns: number;

  /**
   * Custo em PA próprio da habilidade; 0 = o padrão de habilidade (skillCost do painel).
   *
   * @generated from field: int32 ap_cost = 7;
   */
  apCost: number;
};

/**
 * Describes the message ddtank.match.v1.SkillState.
 * Use `create(SkillStateSchema)` to create a new message.
 */
export const SkillStateSchema: GenMessage<SkillState> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 37);

/**
 * Efeito ativo. turns_left conta turnos do próprio alvo e cai ao fim de cada um.
 *
 * @generated from message ddtank.match.v1.EffectState
 */
export type EffectState = Message<"ddtank.match.v1.EffectState"> & {
  /**
   * @generated from field: int32 skill_id = 1;
   */
  skillId: number;

  /**
   * @generated from field: ddtank.match.v1.SkillKind kind = 2;
   */
  kind: SkillKind;

  /**
   * @generated from field: string source_id = 3;
   */
  sourceId: string;

  /**
   * Atributo alterado (buff/debuff): strength, dexterity, constitution, intelligence, wisdom ou charisma. Vazio nos demais.
   *
   * @generated from field: string attribute = 4;
   */
  attribute: string;

  /**
   * Pontos somados (buff) ou tirados (debuff, negativo); fator de dano 0 a 1 na provocação.
   *
   * @generated from field: double amount = 5;
   */
  amount: number;

  /**
   * @generated from field: int32 turns_left = 6;
   */
  turnsLeft: number;
};

/**
 * Describes the message ddtank.match.v1.EffectState.
 * Use `create(EffectStateSchema)` to create a new message.
 */
export const EffectStateSchema: GenMessage<EffectState> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 38);

/**
 * Uma habilidade usada. Todos os jogadores da partida a recebem.
 *
 * @generated from message ddtank.match.v1.SkillUsed
 */
export type SkillUsed = Message<"ddtank.match.v1.SkillUsed"> & {
  /**
   * @generated from field: string caster_id = 1;
   */
  casterId: string;

  /**
   * @generated from field: int32 skill_id = 2;
   */
  skillId: number;

  /**
   * @generated from field: string target_id = 3;
   */
  targetId: string;

  /**
   * @generated from field: ddtank.match.v1.SkillKind kind = 4;
   */
  kind: SkillKind;

  /**
   * Sangue curado (cura), pontos do efeito (buff/debuff, com sinal), fator de dano (provocação) ou passos andados (dash).
   *
   * @generated from field: double amount = 5;
   */
  amount: number;

  /**
   * @generated from field: bool critical = 6;
   */
  critical: boolean;

  /**
   * Sangue do alvo depois.
   *
   * @generated from field: int32 blood_after = 7;
   */
  bloodAfter: number;

  /**
   * Posição do alvo depois (no dash, a do próprio usuário).
   *
   * @generated from field: ddtank.common.v1.Vector2 position = 8;
   */
  position?: Vector2 | undefined;

  /**
   * PA e trecho de movimento que sobram ao usuário.
   *
   * @generated from field: int32 action_points = 9;
   */
  actionPoints: number;

  /**
   * @generated from field: int32 move_allowance = 10;
   */
  moveAllowance: number;

  /**
   * @generated from field: int32 cooldown_turns = 11;
   */
  cooldownTurns: number;

  /**
   * @generated from field: int32 duration_turns = 12;
   */
  durationTurns: number;

  /**
   * @generated from field: string attribute = 13;
   */
  attribute: string;
};

/**
 * Describes the message ddtank.match.v1.SkillUsed.
 * Use `create(SkillUsedSchema)` to create a new message.
 */
export const SkillUsedSchema: GenMessage<SkillUsed> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 39);

/**
 * @generated from message ddtank.match.v1.GameStarted
 */
export type GameStarted = Message<"ddtank.match.v1.GameStarted"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: int32 map_id = 2;
   */
  mapId: number;

  /**
   * Dimensões da máscara de colisão do mapa, em pixels.
   *
   * @generated from field: int32 map_width = 3;
   */
  mapWidth: number;

  /**
   * @generated from field: int32 map_height = 4;
   */
  mapHeight: number;

  /**
   * @generated from field: float gravity = 5;
   */
  gravity: number;

  /**
   * @generated from field: float air_resistance = 6;
   */
  airResistance: number;

  /**
   * @generated from field: repeated ddtank.match.v1.Combatant combatants = 7;
   */
  combatants: Combatant[];

  /**
   * Semente do terreno inicial: o cliente carrega a máscara do manifest de assets; o servidor é a fonte da verdade.
   *
   * @generated from field: string terrain_hash = 8;
   */
  terrainHash: string;

  /**
   * Custo em PA do tiro e de uma habilidade sem custo próprio (a tabela de física em vigor), para a interface mostrar o que cada ação gasta.
   *
   * @generated from field: int32 attack_cost = 9;
   */
  attackCost: number;

  /**
   * @generated from field: int32 skill_cost = 10;
   */
  skillCost: number;
};

/**
 * Describes the message ddtank.match.v1.GameStarted.
 * Use `create(GameStartedSchema)` to create a new message.
 */
export const GameStartedSchema: GenMessage<GameStarted> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 40);

/**
 * @generated from message ddtank.match.v1.TurnStarted
 */
export type TurnStarted = Message<"ddtank.match.v1.TurnStarted"> & {
  /**
   * @generated from field: int32 turn_number = 1;
   */
  turnNumber: number;

  /**
   * @generated from field: string account_id = 2;
   */
  accountId: string;

  /**
   * Vento: positivo empurra para a direita.
   *
   * @generated from field: float wind = 3;
   */
  wind: number;

  /**
   * Prazo do turno, em milissegundos, contado a partir de server_time_ms.
   *
   * @generated from field: int32 duration_ms = 4;
   */
  durationMs: number;

  /**
   * @generated from field: int64 server_time_ms = 5;
   */
  serverTimeMs: bigint;
};

/**
 * Describes the message ddtank.match.v1.TurnStarted.
 * Use `create(TurnStartedSchema)` to create a new message.
 */
export const TurnStartedSchema: GenMessage<TurnStarted> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 41);

/**
 * @generated from message ddtank.match.v1.PlayerMoved
 */
export type PlayerMoved = Message<"ddtank.match.v1.PlayerMoved"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: ddtank.common.v1.Vector2 position = 2;
   */
  position?: Vector2 | undefined;

  /**
   * @generated from field: int32 facing = 3;
   */
  facing: number;

  /**
   * @generated from field: int32 action_points = 4;
   */
  actionPoints: number;

  /**
   * @generated from field: int32 move_allowance = 5;
   */
  moveAllowance: number;

  /**
   * Inclinação do chão no novo lugar (graus, positivo: sobe para a direita); também chega para quem só teve o terreno mudado por uma cratera.
   *
   * @generated from field: float tilt = 6;
   */
  tilt: number;

  /**
   * O jogador andou para o vazio, caiu do mapa e morreu.
   *
   * @generated from field: bool fell = 7;
   */
  fell: boolean;
};

/**
 * Describes the message ddtank.match.v1.PlayerMoved.
 * Use `create(PlayerMovedSchema)` to create a new message.
 */
export const PlayerMovedSchema: GenMessage<PlayerMoved> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 42);

/**
 * Um ponto da trajetória, a cada 40 ms de simulação, para o cliente interpolar a animação.
 *
 * @generated from message ddtank.match.v1.TrajectoryPoint
 */
export type TrajectoryPoint = Message<"ddtank.match.v1.TrajectoryPoint"> & {
  /**
   * @generated from field: int32 time_ms = 1;
   */
  timeMs: number;

  /**
   * @generated from field: int32 x = 2;
   */
  x: number;

  /**
   * @generated from field: int32 y = 3;
   */
  y: number;
};

/**
 * Describes the message ddtank.match.v1.TrajectoryPoint.
 * Use `create(TrajectoryPointSchema)` to create a new message.
 */
export const TrajectoryPointSchema: GenMessage<TrajectoryPoint> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 43);

/**
 * @generated from message ddtank.match.v1.DamageEvent
 */
export type DamageEvent = Message<"ddtank.match.v1.DamageEvent"> & {
  /**
   * @generated from field: string target_id = 1;
   */
  targetId: string;

  /**
   * @generated from field: int32 damage = 2;
   */
  damage: number;

  /**
   * @generated from field: int32 critical = 3;
   */
  critical: number;

  /**
   * @generated from field: int32 blood_after = 4;
   */
  bloodAfter: number;

  /**
   * @generated from field: bool killed = 5;
   */
  killed: boolean;

  /**
   * Dano mágico (o cliente o mostra em rosa/roxo); falso = físico (laranja). Crítico: critical > 0.
   *
   * @generated from field: bool magic = 6;
   */
  magic: boolean;
};

/**
 * Describes the message ddtank.match.v1.DamageEvent.
 * Use `create(DamageEventSchema)` to create a new message.
 */
export const DamageEventSchema: GenMessage<DamageEvent> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 44);

/**
 * Resultado completo de um tiro: o cliente só reproduz, não calcula.
 *
 * @generated from message ddtank.match.v1.ShotResolved
 */
export type ShotResolved = Message<"ddtank.match.v1.ShotResolved"> & {
  /**
   * @generated from field: string shooter_id = 1;
   */
  shooterId: string;

  /**
   * @generated from field: repeated ddtank.match.v1.TrajectoryPoint trajectory = 2;
   */
  trajectory: TrajectoryPoint[];

  /**
   * Local da explosão. Ausente (flew_out) se o projétil saiu do mapa.
   *
   * @generated from field: ddtank.common.v1.Vector2 impact = 3;
   */
  impact?: Vector2 | undefined;

  /**
   * @generated from field: bool flew_out = 4;
   */
  flewOut: boolean;

  /**
   * Cratera aberta no terreno (centro do impacto); false se um alvo é imune a buracos.
   *
   * @generated from field: bool dug = 5;
   */
  dug: boolean;

  /**
   * @generated from field: int32 crater_id = 6;
   */
  craterId: number;

  /**
   * @generated from field: repeated ddtank.match.v1.DamageEvent damages = 7;
   */
  damages: DamageEvent[];

  /**
   * Posições finais de quem caiu depois da explosão.
   *
   * @generated from field: repeated ddtank.match.v1.PlayerMoved relocated = 8;
   */
  relocated: PlayerMoved[];

  /**
   * Bomba cujo desenho o cliente usa (tabela Ball do legado): a animação do projétil e da explosão. Pode diferir da bomba que decidiu o dano, quando a arma tem
   * estágio visual para o nível dela (ADR 0032); a cratera vem em crater_id e o raio em radius.
   *
   * @generated from field: int32 ball_id = 9;
   */
  ballId: number;

  /**
   * @generated from field: bool special = 10;
   */
  special: boolean;

  /**
   * Raio da explosão em pixels (Ball.Radii), para o cliente desenhar o efeito.
   *
   * @generated from field: int32 radius = 11;
   */
  radius: number;

  /**
   * PA e trecho de movimento que sobram ao atirador depois do tiro.
   *
   * @generated from field: int32 action_points = 12;
   */
  actionPoints: number;

  /**
   * @generated from field: int32 move_allowance = 13;
   */
  moveAllowance: number;

  /**
   * Se sobrou PA, o turno continua: nova duração total do turno (a partir de TurnStarted.server_time_ms), com a pausa do tiro somada.
   * 0 = o turno acabou com o tiro (vem um TurnStarted em seguida).
   *
   * @generated from field: int32 turn_duration_ms = 14;
   */
  turnDurationMs: number;

  /**
   * Instante (ms Unix, relógio do servidor) até o qual o atirador não pode agir (o tiro está sendo reproduzido). 0 = sem pausa.
   *
   * @generated from field: int64 locked_until_ms = 15;
   */
  lockedUntilMs: bigint;
};

/**
 * Describes the message ddtank.match.v1.ShotResolved.
 * Use `create(ShotResolvedSchema)` to create a new message.
 */
export const ShotResolvedSchema: GenMessage<ShotResolved> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 45);

/**
 * Estado completo para quem reconecta; o terreno é refeito pelo cliente reaplicando as crateras.
 *
 * @generated from message ddtank.match.v1.GameSnapshot
 */
export type GameSnapshot = Message<"ddtank.match.v1.GameSnapshot"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: int32 turn_number = 2;
   */
  turnNumber: number;

  /**
   * @generated from field: string current_player_id = 3;
   */
  currentPlayerId: string;

  /**
   * @generated from field: float wind = 4;
   */
  wind: number;

  /**
   * @generated from field: repeated ddtank.match.v1.Combatant combatants = 5;
   */
  combatants: Combatant[];

  /**
   * @generated from field: repeated ddtank.match.v1.Crater craters = 6;
   */
  craters: Crater[];

  /**
   * @generated from field: int32 turn_remaining_ms = 7;
   */
  turnRemainingMs: number;

  /**
   * O jogador da vez já atirou neste turno.
   *
   * @generated from field: bool has_fired = 8;
   */
  hasFired: boolean;

  /**
   * Relógio do servidor e instante (ms Unix) em que o turno atual começa (pode estar no futuro, durante a animação do tiro anterior).
   *
   * @generated from field: int64 server_time_ms = 9;
   */
  serverTimeMs: bigint;

  /**
   * @generated from field: int64 turn_starts_at_ms = 10;
   */
  turnStartsAtMs: bigint;

  /**
   * @generated from field: int32 duration_ms = 11;
   */
  durationMs: number;

  /**
   * Instante (ms Unix) até o qual o jogador da vez não pode agir (tiro em reprodução). 0 = livre.
   *
   * @generated from field: int64 locked_until_ms = 12;
   */
  lockedUntilMs: bigint;

  /**
   * O mapa da partida (os mesmos campos do GameStarted): quem reconecta não recebe o GameStarted e precisa deles para carregar a arte e a câmera.
   *
   * @generated from field: int32 map_id = 13;
   */
  mapId: number;

  /**
   * @generated from field: int32 map_width = 14;
   */
  mapWidth: number;

  /**
   * @generated from field: int32 map_height = 15;
   */
  mapHeight: number;

  /**
   * @generated from field: float gravity = 16;
   */
  gravity: number;

  /**
   * @generated from field: float air_resistance = 17;
   */
  airResistance: number;

  /**
   * @generated from field: string terrain_hash = 18;
   */
  terrainHash: string;

  /**
   * @generated from field: int32 attack_cost = 19;
   */
  attackCost: number;

  /**
   * @generated from field: int32 skill_cost = 20;
   */
  skillCost: number;
};

/**
 * Describes the message ddtank.match.v1.GameSnapshot.
 * Use `create(GameSnapshotSchema)` to create a new message.
 */
export const GameSnapshotSchema: GenMessage<GameSnapshot> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 46);

/**
 * @generated from message ddtank.match.v1.Crater
 */
export type Crater = Message<"ddtank.match.v1.Crater"> & {
  /**
   * @generated from field: int32 crater_id = 1;
   */
  craterId: number;

  /**
   * @generated from field: int32 x = 2;
   */
  x: number;

  /**
   * @generated from field: int32 y = 3;
   */
  y: number;
};

/**
 * Describes the message ddtank.match.v1.Crater.
 * Use `create(CraterSchema)` to create a new message.
 */
export const CraterSchema: GenMessage<Crater> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 47);

/**
 * @generated from message ddtank.match.v1.PlayerResult
 */
export type PlayerResult = Message<"ddtank.match.v1.PlayerResult"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: ddtank.match.v1.Team team = 2;
   */
  team: Team;

  /**
   * @generated from field: bool winner = 3;
   */
  winner: boolean;

  /**
   * @generated from field: int32 damage_dealt = 4;
   */
  damageDealt: number;

  /**
   * @generated from field: int32 kills = 5;
   */
  kills: number;

  /**
   * @generated from field: bool alive = 6;
   */
  alive: boolean;
};

/**
 * Describes the message ddtank.match.v1.PlayerResult.
 * Use `create(PlayerResultSchema)` to create a new message.
 */
export const PlayerResultSchema: GenMessage<PlayerResult> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 48);

/**
 * @generated from message ddtank.match.v1.GameFinished
 */
export type GameFinished = Message<"ddtank.match.v1.GameFinished"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: ddtank.match.v1.Team winner = 2;
   */
  winner: Team;

  /**
   * @generated from field: ddtank.match.v1.GameEndReason reason = 3;
   */
  reason: GameEndReason;

  /**
   * @generated from field: int32 turns = 4;
   */
  turns: number;

  /**
   * @generated from field: repeated ddtank.match.v1.PlayerResult players = 5;
   */
  players: PlayerResult[];
};

/**
 * Describes the message ddtank.match.v1.GameFinished.
 * Use `create(GameFinishedSchema)` to create a new message.
 */
export const GameFinishedSchema: GenMessage<GameFinished> = /*@__PURE__*/
  messageDesc(file_ddtank_match_v1_match, 49);

/**
 * @generated from enum ddtank.match.v1.ErrorCode
 */
export enum ErrorCode {
  /**
   * @generated from enum value: ERROR_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ERROR_CODE_INVALID_MESSAGE = 1;
   */
  INVALID_MESSAGE = 1,

  /**
   * @generated from enum value: ERROR_CODE_NOT_IN_ROOM = 2;
   */
  NOT_IN_ROOM = 2,

  /**
   * @generated from enum value: ERROR_CODE_ALREADY_IN_ROOM = 3;
   */
  ALREADY_IN_ROOM = 3,

  /**
   * @generated from enum value: ERROR_CODE_ROOM_NOT_FOUND = 4;
   */
  ROOM_NOT_FOUND = 4,

  /**
   * @generated from enum value: ERROR_CODE_ROOM_FULL = 5;
   */
  ROOM_FULL = 5,

  /**
   * @generated from enum value: ERROR_CODE_WRONG_PASSWORD = 6;
   */
  WRONG_PASSWORD = 6,

  /**
   * @generated from enum value: ERROR_CODE_NOT_ROOM_OWNER = 7;
   */
  NOT_ROOM_OWNER = 7,

  /**
   * @generated from enum value: ERROR_CODE_NOT_READY = 8;
   */
  NOT_READY = 8,

  /**
   * @generated from enum value: ERROR_CODE_GAME_IN_PROGRESS = 9;
   */
  GAME_IN_PROGRESS = 9,

  /**
   * @generated from enum value: ERROR_CODE_ALREADY_QUEUED = 10;
   */
  ALREADY_QUEUED = 10,

  /**
   * @generated from enum value: ERROR_CODE_NOT_YOUR_TURN = 11;
   */
  NOT_YOUR_TURN = 11,

  /**
   * @generated from enum value: ERROR_CODE_NOT_IN_GAME = 12;
   */
  NOT_IN_GAME = 12,

  /**
   * Pontos de ação (PA) insuficientes para a ação pedida.
   *
   * @generated from enum value: ERROR_CODE_NO_ACTION_POINTS = 13;
   */
  NO_ACTION_POINTS = 13,

  /**
   * @generated from enum value: ERROR_CODE_RATE_LIMITED = 14;
   */
  RATE_LIMITED = 14,

  /**
   * @generated from enum value: ERROR_CODE_UNAVAILABLE = 15;
   */
  UNAVAILABLE = 15,

  /**
   * @generated from enum value: ERROR_CODE_NO_SPECIAL = 16;
   */
  NO_SPECIAL = 16,

  /**
   * @generated from enum value: ERROR_CODE_ALREADY_FIRED = 17;
   */
  ALREADY_FIRED = 17,

  /**
   * A partida do jogador está em outra instância do Match; o detail traz o id da sala. Reconecte com ?room=<id> (afinidade no Gateway).
   *
   * @generated from enum value: ERROR_CODE_WRONG_INSTANCE = 18;
   */
  WRONG_INSTANCE = 18,

  /**
   * O tiro anterior ainda está sendo reproduzido: aguarde o fim da pausa (ShotResolved.locked_until_ms).
   *
   * @generated from enum value: ERROR_CODE_BUSY = 19;
   */
  BUSY = 19,

  /**
   * Habilidade que o jogador não tem, em cooldown ou com alvo inválido.
   *
   * @generated from enum value: ERROR_CODE_UNKNOWN_SKILL = 20;
   */
  UNKNOWN_SKILL = 20,

  /**
   * @generated from enum value: ERROR_CODE_SKILL_ON_COOLDOWN = 21;
   */
  SKILL_ON_COOLDOWN = 21,

  /**
   * @generated from enum value: ERROR_CODE_INVALID_TARGET = 22;
   */
  INVALID_TARGET = 22,

  /**
   * A sala está na fila de partidas: ninguém entra nem inicia por fora até o dono cancelar a busca.
   *
   * @generated from enum value: ERROR_CODE_ROOM_QUEUED = 23;
   */
  ROOM_QUEUED = 23,

  /**
   * Entrar na fila exige arma equipada em todos os membros da sala. O detail traz os apelidos de quem não tem (ou diz que o Character não respondeu).
   *
   * @generated from enum value: ERROR_CODE_WEAPON_REQUIRED = 24;
   */
  WEAPON_REQUIRED = 24,

  /**
   * O alvo do convite não está na lista de amigos do jogador (ou bloqueou o jogador).
   *
   * @generated from enum value: ERROR_CODE_NOT_FRIEND = 25;
   */
  NOT_FRIEND = 25,

  /**
   * O amigo está offline, numa partida ou já na mesma sala.
   *
   * @generated from enum value: ERROR_CODE_FRIEND_UNAVAILABLE = 26;
   */
  FRIEND_UNAVAILABLE = 26,

  /**
   * Convite repetido ao mesmo amigo em menos de 10 segundos.
   *
   * @generated from enum value: ERROR_CODE_INVITE_TOO_SOON = 27;
   */
  INVITE_TOO_SOON = 27,

  /**
   * O Character não respondeu: sem a lista de amigos o Match não convida (falha fechado).
   *
   * @generated from enum value: ERROR_CODE_FRIENDS_UNAVAILABLE = 28;
   */
  FRIENDS_UNAVAILABLE = 28,
}

/**
 * Describes the enum ddtank.match.v1.ErrorCode.
 */
export const ErrorCodeSchema: GenEnum<ErrorCode> = /*@__PURE__*/
  enumDesc(file_ddtank_match_v1_match, 0);

/**
 * @generated from enum ddtank.match.v1.RoomStatus
 */
export enum RoomStatus {
  /**
   * @generated from enum value: ROOM_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ROOM_STATUS_WAITING = 1;
   */
  WAITING = 1,

  /**
   * @generated from enum value: ROOM_STATUS_PLAYING = 2;
   */
  PLAYING = 2,
}

/**
 * Describes the enum ddtank.match.v1.RoomStatus.
 */
export const RoomStatusSchema: GenEnum<RoomStatus> = /*@__PURE__*/
  enumDesc(file_ddtank_match_v1_match, 1);

/**
 * @generated from enum ddtank.match.v1.Team
 */
export enum Team {
  /**
   * @generated from enum value: TEAM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TEAM_A = 1;
   */
  A = 1,

  /**
   * @generated from enum value: TEAM_B = 2;
   */
  B = 2,
}

/**
 * Describes the enum ddtank.match.v1.Team.
 */
export const TeamSchema: GenEnum<Team> = /*@__PURE__*/
  enumDesc(file_ddtank_match_v1_match, 2);

/**
 * @generated from enum ddtank.match.v1.RoomClosedReason
 */
export enum RoomClosedReason {
  /**
   * @generated from enum value: ROOM_CLOSED_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ROOM_CLOSED_REASON_LEFT = 1;
   */
  LEFT = 1,

  /**
   * @generated from enum value: ROOM_CLOSED_REASON_EMPTY = 2;
   */
  EMPTY = 2,

  /**
   * @generated from enum value: ROOM_CLOSED_REASON_FINISHED = 3;
   */
  FINISHED = 3,

  /**
   * O dono da sala expulsou o jogador.
   *
   * @generated from enum value: ROOM_CLOSED_REASON_KICKED = 4;
   */
  KICKED = 4,
}

/**
 * Describes the enum ddtank.match.v1.RoomClosedReason.
 */
export const RoomClosedReasonSchema: GenEnum<RoomClosedReason> = /*@__PURE__*/
  enumDesc(file_ddtank_match_v1_match, 3);

/**
 * @generated from enum ddtank.match.v1.SkillKind
 */
export enum SkillKind {
  /**
   * @generated from enum value: SKILL_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SKILL_KIND_DASH = 1;
   */
  DASH = 1,

  /**
   * @generated from enum value: SKILL_KIND_BUFF = 2;
   */
  BUFF = 2,

  /**
   * @generated from enum value: SKILL_KIND_DEBUFF = 3;
   */
  DEBUFF = 3,

  /**
   * @generated from enum value: SKILL_KIND_TAUNT = 4;
   */
  TAUNT = 4,

  /**
   * @generated from enum value: SKILL_KIND_HEAL = 5;
   */
  HEAL = 5,
}

/**
 * Describes the enum ddtank.match.v1.SkillKind.
 */
export const SkillKindSchema: GenEnum<SkillKind> = /*@__PURE__*/
  enumDesc(file_ddtank_match_v1_match, 4);

/**
 * @generated from enum ddtank.match.v1.SkillTarget
 */
export enum SkillTarget {
  /**
   * @generated from enum value: SKILL_TARGET_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SKILL_TARGET_SELF = 1;
   */
  SELF = 1,

  /**
   * @generated from enum value: SKILL_TARGET_ALLY = 2;
   */
  ALLY = 2,

  /**
   * @generated from enum value: SKILL_TARGET_ENEMY = 3;
   */
  ENEMY = 3,
}

/**
 * Describes the enum ddtank.match.v1.SkillTarget.
 */
export const SkillTargetSchema: GenEnum<SkillTarget> = /*@__PURE__*/
  enumDesc(file_ddtank_match_v1_match, 5);

/**
 * @generated from enum ddtank.match.v1.GameEndReason
 */
export enum GameEndReason {
  /**
   * @generated from enum value: GAME_END_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GAME_END_REASON_ELIMINATION = 1;
   */
  ELIMINATION = 1,

  /**
   * @generated from enum value: GAME_END_REASON_FORFEIT = 2;
   */
  FORFEIT = 2,

  /**
   * @generated from enum value: GAME_END_REASON_TURN_LIMIT = 3;
   */
  TURN_LIMIT = 3,
}

/**
 * Describes the enum ddtank.match.v1.GameEndReason.
 */
export const GameEndReasonSchema: GenEnum<GameEndReason> = /*@__PURE__*/
  enumDesc(file_ddtank_match_v1_match, 6);

